import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { Paths, Urls } from "../../../constants/UrlConstants";
import Contentify from "../../../content/Contentify";
import Store from "../../../content/Store";
import Article from "../../shared/Article";
import SummaryDetail from "../../shared/groups/SummaryDetail";
import SummaryDetailRow from "../../shared/groups/SummaryDetailRow";
import ShadowedContainer from "../../shared/containers/ShadowedContainer";
import { connect } from "react-redux";
import styles from "../../../assets/css/modules/claims/claim-details.css";
import InvoiceRow from "./InvoiceRow";
import HelpSection from "../../shared/HelpSection";
import PromoImageCard from "../../shared/PromoImageCard";
import PromoContainer from "../../shared/containers/PromoContainer";
import ClaimDetailsActionButtons from "./ClaimDetailsActionButtons";
import { EPDomain_ROOT } from "../../../constants/EP-config";
import EPQueryParams from "../../../constants/EPQueryParams";

export const mapStateToClaimDetails = (state) => {
  return {
    selectedClaimSummary: state.claimsReducer.selectedPolicy.selectedClaim,
    featureFlagEP: state.unreadMessagesReducer.featureFlagEP,
    IsInternalView: state.policyReducer && state.policyReducer.policyDetails 
    && state.policyReducer.policyDetails.IsInternalView,
  };
};

export const getContentForClaimStatus = (status, statusContent) => {
  if (status === "Approved") {
    return statusContent.Approved;
  }else if (status === "On Hold") {
    return statusContent.OnHold;}
   else if (status === "Pending") {
    return statusContent.Pending;
  } else if (status === "Closed") {
    return statusContent.Closed;
  } else if (status === "Not covered") {
    return statusContent.NotCovered;
  } else{
    return ;
  }
};

export class ClaimDetails extends Component {
  static content = Store.ClaimDetails;

  constructor(props) {
    super(props);
    this.state = {
      Authurl:Urls.EngagementPortal[EPDomain_ROOT].preauth,
      ClaimBackUrl : Urls.EngagementPortal[EPDomain_ROOT].claimBackPayment,
    };
  }

  handleAuthCallback = (childData) => {
    this.setState({ Authurl: childData });
  };

  handleClaimCallback = (childData) => {
    this.setState({ ClaimBackUrl: childData });
  };

  componentDidUpdate() {
    if (!this.props.selectedClaimSummary) {
      this.props.history.push(Paths.Claims);
    }
  }

  render() {
    let invoiceSectionDetail = this.props.content.noInvoicesMessage;
    if (
      this.props.selectedClaimSummary &&
      this.props.selectedClaimSummary.ClaimDetails.Invoices.length
    ) {
      invoiceSectionDetail = this.props.content.invoiceDetails;
    }

    return (
      <div className={styles.claimDetails}>
        <div className="container">
          <div className="back-button">
            <Link to={Paths.Claims}>
              <span className="mr-2 left-arrow-back">←</span>{" "}
              {this.props.content.backToMyClaims}
            </Link>
          </div>
        </div>
        <EPQueryParams url={this.state.Authurl} updatedURL={this.handleAuthCallback}/>
        <EPQueryParams url={this.state.ClaimBackUrl} updatedURL={this.handleClaimCallback}/> 
        {this.props.selectedClaimSummary ? (
          <ShadowedContainer>
            <div className="row">
              <div className="col-lg-8">
                <Article
                  header={this.props.content.header}
                  body={this.props.content.details}
                />
                <div className={styles.summaryContainer}>
                  <SummaryDetail>
                    <SummaryDetailRow
                      title={this.props.content.claimNumberLabel}
                      value={this.props.selectedClaimSummary.ClaimNumber}
                      tooltipIcon="icon-info-blue"
                      tooltipContent={this.props.content.claimNumberTooltip}
                      customValueStyle={styles.summaryValueStyle}
                    />
                    <SummaryDetailRow
                      title={this.props.content.conditionLabel}
                      value={this.props.selectedClaimSummary.ClaimCondition}
                      customValueStyle={
                        styles.conditionValueStyle + " " + styles.iconSpacing
                      }
                    />
                    {!["Optical Care","Dental Care","Doctor@Hand","Private GP Fees","Health Assessment","Vaccinations","Accidental Death"].includes(this.props.selectedClaimSummary.ClaimCondition) ? (
                    <SummaryDetailRow
                      title={this.props.content.conditionStatusLabel}
                      value={this.props.selectedClaimSummary.ClaimSubStatus}
                      tooltipIcon="icon-info-blue"
                      tooltipContent={getContentForClaimStatus(
                        this.props.selectedClaimSummary.ClaimSubStatus,
                        this.props.content.conditionStatusTooltip
                      )}
                      customValueStyle={styles.summaryValueStyle}
                    />): null}
                    <SummaryDetailRow
                      title={this.props.content.dateNotifiedLabel}
                      value={this.props.selectedClaimSummary.DateNotified}
                      customValueStyle={
                        styles.summaryValueStyle + " " + styles.iconSpacing
                      }
                    />
                  </SummaryDetail>
                </div>
              </div>
              <div className="col-4 text-right d-none d-lg-block">
                <div className="d-inline-block text-left">
                  <ClaimDetailsActionButtons
                    authoriseTreatmentButtonId="authoriseTreatmentButtonDesktop"
                    uploadInvoiceButtonId="uploadInvoiceButtonDesktop"
                    authoriseTreatmentDesc={
                      this.props.content.authoriseTreatmentDesc
                    }
                    authoriseTreatmentButtonLabel={
                      this.props.content.authoriseTreatmentButtonLabel
                    }
                    uploadInvoiceDesc={this.props.content.uploadInvoiceDesc}
                    uploadInvoiceButtonLabel={
                      this.props.content.uploadInvoiceButtonLabel
                    }
                    uploadInvoiceButtonType={
                      this.props.content.uploadInvoiceButtonType
                    }
                  />
                </div>
              </div>
            </div>
            <div className={"row " + styles.invoiceRowContainer}>
              <div className="col-12">
                <div className={styles.sectionBorderTop}>
                  <div className="row">
                    <div className="col-lg-9">
                      <Article
                        header={this.props.content.invoiceHeader}
                        body={invoiceSectionDetail}
                      />
                    </div>
                  </div>
                  {this.props.selectedClaimSummary.ClaimDetails.Invoices.map(
                    (invoice, key) => (
                      <InvoiceRow
                        key={key}
                        invoice={invoice}
                        claimReference={
                          this.props.selectedClaimSummary.ClaimNumber
                        }
                      />
                    )
                  )}
                </div>
              </div>
            </div>
            <div className="d-lg-none text-center">
              <ClaimDetailsActionButtons
                authoriseTreatmentButtonId="authoriseTreatmentButtonMobile"
                uploadInvoiceButtonId="uploadInvoiceButtonMobile"
                authoriseTreatmentDesc={
                  this.props.content.authoriseTreatmentDesc
                }
                authoriseTreatmentButtonLabel={
                  this.props.content.authoriseTreatmentButtonLabel
                }
                uploadInvoiceDesc={this.props.content.uploadInvoiceDesc}
                uploadInvoiceButtonLabel={
                  this.props.content.uploadInvoiceButtonLabel
                }
              />
            </div>
            <div className="mt-4">
              <HelpSection
                HeadingLinkTo={this.props.content.HelpSection.HeadingLinkTo}
                HeadingLinkText={this.props.content.HelpSection.HeadingLinkText}
                MoreHelpLinkTo={this.props.content.HelpSection.MoreHelpLinkTo}
                MoreHelpLinkText={
                  this.props.content.HelpSection.MoreHelpLinkText
                }
                HelpSet={
                  this.props.featureFlagEP === false || this.props.featureFlagEP === undefined ?
                this.props.content.HelpSet :
                this.props.content.HelpSetEP(this.state.Authurl, this.state.ClaimBackUrl,this.props.IsInternalView)}
              />
            </div>
          </ShadowedContainer>
        ) : null}
        <PromoContainer>
          <PromoImageCard
            LinkTo={this.props.content.Promo.LinkTo}
            LinkText={this.props.content.Promo.LinkText}
            LeftImage
            ImgSrc={this.props.content.Promo.ImgSrc}
            ImgSrcMobile={this.props.content.Promo.ImgSrcMobile}
            Heading={this.props.content.Promo.Heading}
            Description={this.props.content.Promo.Description}
            aria-label={this.props.content.Promo.AriaLabel}
          />
        </PromoContainer>
      </div>
    );
  }
}

export default withRouter(
  connect(mapStateToClaimDetails)(Contentify(ClaimDetails))
);
